export default
{
    design: 1600,
    xl: 1440,
    lg: 1280,
    md: 1024,
    sm: 960,
    xs: 770,
    xxs: 480
}



// WEBPACK FOOTER //
// ./src/scripts/constants/breakpoints.js